import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import PageMessage from "2g-page-message";
import useNotifikaceWidget from "./useNotifikaceWidget";
import NotifikaceItem from "./NotifikaceItem";
import useMessages from "./i18n/useMessages";

export function NotifikaceWidget({ notifikace = [], onClose, onSuccess }) {
  const { title, emptyMessage } = useMessages();
  const { headerActions, onClick, onRead, onDelete } = useNotifikaceWidget({
    notifikace,
    onClose,
    onSuccess
  });
  return (
    <Widget
      title={title()}
      collapsable={false}
      headerActions={headerActions}
      className="b2b-Notifikace-widget"
    >
      {notifikace?.length > 0 ? (
        notifikace.map(notifikaceItem => (
          <NotifikaceItem
            notifikace={notifikaceItem}
            key={notifikaceItem.id}
            onClick={onClick}
            onRead={onRead}
            onDelete={onDelete}
          />
        ))
      ) : (
        <PageMessage inline>{emptyMessage()}</PageMessage>
      )}
    </Widget>
  );
}

NotifikaceWidget.propTypes = {
  onClose: T.func,
  onSuccess: T.func,
  notifikace: T.array
};

export default React.memo(NotifikaceWidget);
